<svg class="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 98.05 100">
    <g>
        <path d="M24.46,28,49,13.58,27.28.77a5.53,5.53,0,0,0-5.64,0L0,13.5V39.29a5.67,5.67,0,0,0,2.78,4.88L24.46,57Z" class="color-neutral"/>
        <path d="M49,71.53,73.59,57V82.5a5.39,5.39,0,0,1-2.67,4.66L49,100,27,87.07a5.1,5.1,0,0,1-2.52-4.4V57Z" class="color-dark"/>
        <path d="M73.59,28V57L95.32,44.14a5.54,5.54,0,0,0,2.73-4.79V13.5L76.41.77a5.53,5.53,0,0,0-5.64,0L49,13.58Z" class="color-light"/>
        <polygon points="67.28 53.05 49.03 63.59 30.77 53.05 49.01 42.5 67.28 53.05" class="color-dark"/>
        <polygon points="30.77 53.05 30.77 31.97 49.02 21.43 49.02 42.51 30.77 53.05" class="color-neutral"/>
        <polygon points="49.03 42.51 49.02 21.43 49.03 21.43 67.28 31.97 67.28 53.05 49.03 42.51" class="color-light"/>
    </g>
</svg>

<div class="spinner mt-5">
    <svg preserveAspectRatio="xMidYMid meet" focusable="false" viewBox="0 0 100 100">
        <circle cx="50%" cy="50%" r="45"></circle>
    </svg>
</div>
